import React from 'react';
import {connect} from 'react-redux';
import {initResponseStatus, setResponseStatus} from './redux/actions.responseStatus';
import img404 from '../../assets/404.png';

class NotFoundComponent extends React.Component {
  componentWillMount() {
    this.props.dispatch(setResponseStatus(404));
  }

  componentWillUnmount() {
    this.props.dispatch(initResponseStatus());
  }

  render() {
    return (
      <div className="not-found row">
        <div className="small-4 columns">
          <img src={img404}/>
        </div>
        <div className="small-8 columns">
          <h2>Ooops.. Page Not Found!</h2>
        </div>
      </div>
    );
  }
}

NotFoundComponent.displayName = 'NotFoundComponent';

export default connect()(NotFoundComponent);


// WEBPACK FOOTER //
// ./shared/common/NotFound.Component.jsx